import React, { useEffect, useState } from "react";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  TitleWrapper,
  LegislationWindowContainer,
  ContentWrapper,
  BackToGuidesWrapper,
  NoDataContainer,
  SvgContainer,
} from "./LegislationWindowStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//ASETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";
import legislationService from "services/legislationService";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// HOOKS

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import AuthorisationGuideCardAtom from "components/Atoms/AuthorisationGuideCardAtom/AuthorisationGuideCardAtom";

// CONFIGURATION

const LegislationWindow = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [authorisations, setAuthorisations] = useState<any>(null);

  // LIFE CYCLE
  useEffect(() => {
    legislationService
      .getAuthorisations()
      .then((response) => {
        // console.log("getAuthorisations response", response);
        setAuthorisations(response);
      })
      .catch((err) => {
        console.log("getAuthorisations error", err);
      });
  }, []);

  const authorisationData =
    authorisations?.data.map((file: any) => ({
      id: file?.id,
      title: file?.attributes?.title,
      type: file?.attributes?.type,
      pdfUrl: `https://www.ijsunt.ro/ghid/`,
    })) || [];

  // EVENT HANDLERS

  return (
    <LegislationWindowContainer>
      <BackToGuidesWrapper
        biggerCursor={biggerCursor}
        onClick={() => navigate(appRoutes.legislation)}
      >
        <BackToGuidesImage src={LeftArrow} alt="backIcon" />
        <BackToGuidesButton>
          <CustomText
            text={t("view.legislationWindow.button")}
            type={TextType.H5boldspaced}
            color={COLORS.RaisinBlack}
          />
        </BackToGuidesButton>
      </BackToGuidesWrapper>
      <TitleWrapper>
        <CustomText
          type={TextType.H2}
          text={t("view.legislationWindow.title")}
        />
      </TitleWrapper>

      {authorisationData.length > 0 ? (
        <ContentWrapper>
          {authorisationData.map((file) => (
            <AuthorisationGuideCardAtom
              key={file.id}
              documentType={file.type}
              title={file.title}
              pdfUrl={file.pdfUrl}
            />
          ))}
        </ContentWrapper>
      ) : (
        <NoDataContainer>
          <SvgContainer>
            <NoDataDark />
          </SvgContainer>
          <CustomText
            text={t("app.noData")}
            type={TextType.P1}
            color={COLORS.MetalicSilver}
          />
        </NoDataContainer>
      )}
    </LegislationWindowContainer>
  );
};

export default LegislationWindow;
